<template>
    <v-row class="d-flex flex-wrap justify-space-between fareWrap">
        <v-col v-if="isLoading" cols="12">
            <flight-loader :is-loading="isLoading" />
        </v-col>

        <v-carousel hide-delimiters height="max-content">
            <v-carousel-item v-for="(chunck, index) in chunked" :key="`${index}-chunk`">
                <v-row class="px-12 py-2">
                    <v-col v-for="chunkOffer in chunck" :key="chunkOffer.offerKey" cols="12" md="4">
                        <fare-offer :offer="chunkOffer" />
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>
    </v-row>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FareOffer from '~/components/flights/search/offers/FareOffer.vue'
    import {chunkArray} from '~/utils/helpers'
    import FlightLoader from '@/components/flights/snippets/FlightLoader.vue'
    import searchFlightRsTransformer from '~/api/flights/searchFlightRsTransformer'

    @Component({
        components: {
            FareOffer,
            FlightLoader,
        },
    })
    export class FlightFareOptions extends Vue {
        @Prop({required: true}) offer

        options = []
        chunked = []
        isLoading = false

        created() {
            this.getFareOptions()
        }

        async getFareOptions() {
            this.isLoading = true
            const rq = {
                offerKey: this.offer.fferKey,
            }
            const offers = this.offer.fareOffersArray
                ? this.offer.fareOffersArray
                : searchFlightRsTransformer(await this.$api.flightFareOptions.get(rq)).offers
            this.options = this.formatOptions([clone(this.offer), ...offers])
            this.isLoading = false
        }

        formatOptions(offers) {
            if (offers.length) {
                const result = offers.map(offer => {
                    const offerTariff = {}
                    offer.itinerary.forEach(({segments}) => {
                        segments.forEach(seg => {
                            const brandedFareName = seg.brandedFareName
                            const fareDescriptions = seg.fareDescriptions
                            const departureAirportDescription = seg.departure.airportDescription
                            const arrivalAirportDescription = seg.arrival.airportDescription
                            const departureDate = seg.departure.date
                            const arrivalDate = seg.arrival.date
                            const categoryClass = seg.class

                            if (!offerTariff[brandedFareName]) {
                                offerTariff[brandedFareName] = {
                                    name: brandedFareName,
                                    description: fareDescriptions,
                                    routes: [],
                                    classes: [],
                                }
                                offerTariff[brandedFareName].routes.push({
                                    departureAirportDescription,
                                    arrivalAirportDescription,
                                    departureDate,
                                    arrivalDate,
                                })
                                if (categoryClass && categoryClass.classType) {
                                    offerTariff[brandedFareName].classes.push(categoryClass.classType)
                                }
                            } else {
                                offerTariff[brandedFareName].routes.push({
                                    departureAirportDescription,
                                    arrivalAirportDescription,
                                    departureDate,
                                    arrivalDate,
                                })
                            }
                        })
                    })
                    offer.tariff = offerTariff
                    return offer
                })
                this.chunked = chunkArray(result, !this.$breakpoint.smAndDown ? 3 : 1)
                return result
            }
            return []
        }
    }

    export default FlightFareOptions
</script>

<style scoped>
    :deep(.v-window__prev),
    :deep(.v-window__next) {
        margin-left: 0;
        margin-right: 0;
        background-color: transparent;
    }
</style>
